// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error_wrapper__iqQlj","innerWrapper":"error_innerWrapper__tq87E","textWrapper":"error_textWrapper__n_8tt","logo":"error_logo__GXtaU","dades":"error_dades__TcowL"};